module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable17.be21d071.jpg";